module.exports = __webpack_public_path__ + "static/media/boton-100-min.8976219a.jpg";